export default "__VITE_ASSET___9yO7SUW__"